import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import ptTranslations from './locales/pt.json';
import frTranslations from './locales/fr.json';
import esTranslations from './locales/es.json';

// Fallback language if translation is missing
const FALLBACK_LANGUAGE = 'pt';
const DEFAULT_LANGUAGE = 'pt';

// Supported languages
const SUPPORTED_LANGUAGES = ['en', 'pt', 'fr', 'es'];

const resources = {
  en: {
    translation: enTranslations
  },
  pt: {
    translation: ptTranslations
  },
  fr: {
    translation: frTranslations
  },
  es: {
    translation: esTranslations
  }
};

// Get language from URL parameters
const getLanguageFromURL = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : null;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: FALLBACK_LANGUAGE,
    lng: getLanguageFromURL() || DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
  });

// Helper functions
export const changeLanguage = (language) => {
  if (isLanguageSupported(language)) {
    i18n.changeLanguage(language);
    // Update URL with new language
    const url = new URL(window.location.href);
    url.searchParams.set('lang', language);
    window.history.replaceState({}, '', url);
  }
};

export const getCurrentLanguage = () => {
  return i18n.language;
};

export const isLanguageSupported = (language) => {
  return SUPPORTED_LANGUAGES.includes(language);
};

export const getSupportedLanguages = () => {
  return SUPPORTED_LANGUAGES;
};

export default i18n;
